export enum PeriodicImageUploadStatus {
    Unknown = 0,
    Normal = 1,
    Warning = 2,
    Error = 3,
}
